import React from 'react';
import Recaptcha from 'react-recaptcha';

function BaasicRecaptchaTemplate(props) {
    return <Recaptcha {...props} />
}

export default BaasicRecaptchaTemplate;